import { registerPlugin } from '@capacitor/core';
import { isAndroidNative, isNativePlatform } from './capacitorPlatform';
const NativePdf = registerPlugin('OfflinePdfReader');
const reference = row => ({ path: row.path, sha256: row.sha256, size: row.size });
export async function inspectOfflinePdf(row, bytes) {
    if (isAndroidNative()) {
        const result = await NativePdf.inspect(reference(row));
        if (result.reader !== 'android-pdf-renderer' || !Number.isInteger(result.pages) || result.pages < 1 || result.pages > 200) throw Error('El lector no confirmó las páginas del PDF.');
        return result;
    }
    if (isNativePlatform()) throw Error('Este dispositivo no tiene un lector PDF offline disponible.');
    return (await import('./browserOfflinePdf.js')).inspectBrowserOfflinePdf(row,bytes);
}
export async function renderOfflinePdf(row, pageIndex, bytes) {
    if(!isAndroidNative()) {
        if(isNativePlatform())throw Error('Este dispositivo no tiene un lector PDF offline disponible.');
        return (await import('./browserOfflinePdf.js')).renderBrowserOfflinePdf(row,pageIndex,bytes);
    }
    const result = await NativePdf.render({ ...reference(row), pageIndex });
    if (result.pageIndex !== pageIndex || !Number.isInteger(result.pages) || result.pages < 1 || result.pages > 200
        || !String(result.dataUrl || '').startsWith('data:image/png;base64,') || result.width < 1 || result.width > 1200 || result.height < 1 || result.height > 1600) throw Error('No se confirmó la página del PDF.');
    return result;
}
